import { useQuery } from '@tanstack/react-query';
import { api } from '../api-client.config';
import { queryKeys } from '../react-query.config';

import { FeedPlayer } from './getFeedPlayerById';

interface FeedPlayersResponse {
  players: FeedPlayer[];
}

export type { FeedPlayer };

export const getFeedPlayers = async (teamId: string): Promise<FeedPlayer[]> => {
  const response = (await api.get('/feed/players', {
    params: { teamId },
  })) as FeedPlayersResponse;
  return response.players || [];
};

export const useGetFeedPlayersQuery = (teamId: string | undefined) => {
  return useQuery({
    queryKey: queryKeys.feed.players(teamId || ''),
    queryFn: () => {
      if (!teamId) throw new Error('Team ID is required');
      return getFeedPlayers(teamId);
    },
    enabled: !!teamId,
    staleTime: 2 * 60 * 1000, // 2 minutes - players can change more frequently
  });
};
